import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import './DataList.scss';
import { Checkbox } from '@haldor/ui'; // Need to work on naming for the component

var DataList = /*#__PURE__*/function (_Component) {
  _inherits(DataList, _Component);

  var _super = _createSuper(DataList);

  function DataList(_props) {
    var _this;

    _classCallCheck(this, DataList);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.updateColumns(_this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      _this.updateColumns(nextProps);
    });

    _defineProperty(_assertThisInitialized(_this), "updateColumns", function (props) {
      if (props.data != null && props.data.length > 0) {
        var columns = [];

        if (props.renderRow != null) {
          props.data.forEach(function (item, index) {
            var row = props.renderRow(item, index);

            if (row != null && row.props.children != null) {
              var children = []; // Make sure we keep the children var array
              // row.props.children can be both object and array

              if (Array.isArray(row.props.children)) {
                children = row.props.children;
              } else {
                children = [row.props.children];
              }

              children.forEach(function (rowChild) {
                if (rowChild != null && rowChild.props != null && rowChild.props.title != null) {
                  if (columns.indexOf(rowChild.props.title) == -1) {
                    columns.push(rowChild.props.title);
                  }
                }
              });
            }
          });
        }

        _this.setState({
          columns: columns
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectType", function (type) {
      localStorage.setItem('haldor-datalist-mode', type);

      _this.setState({
        active: type
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTable", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "table"
      }, _this.state.columns.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "row table-head"
      }, _this.state.columns.map(function (column, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cell",
          key: 'column-' + column
        }, _this.props.toggleAllEntries != null && index == 0 ? /*#__PURE__*/React.createElement(Checkbox, {
          onChange: _this.props.toggleAllEntries,
          value: _this.props.allEntriesSelected,
          label: column
        }) : column);
      })) : null, _this.props.data.map(function (item, index) {
        return _this.props.renderRow(item, index);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCards", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "cards-container"
      }, _this.props.data.map(function (item, index) {
        return _this.props.renderCard(item, index);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMain", function () {
      if (_this.props.data.length == 0 && _this.props.emptyData != null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "list-content"
        }, _this.props.emptyData());
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "list-content"
      }, _this.state.active == 'table' ? _this.renderTable() : null, _this.state.active == 'card' ? _this.renderCards() : null);
    });

    var available = [];
    var active = null;
    var preferred = localStorage.getItem('haldor-datalist-mode');

    if (_props.renderRow != null) {
      available.push('table');
    }

    if (_props.renderCard != null) {
      available.push('card');
    }

    if (preferred != null && available.indexOf(preferred) > -1) {
      active = preferred;
    } else {
      active = available[0];
    }

    _this.state = {
      active: active,
      columns: [],
      available: available
    };
    return _this;
  }

  _createClass(DataList, [{
    key: "render",
    value: function render() {
      if (this.props.data == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "list-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "list-header"
      }, this.props.title ? /*#__PURE__*/React.createElement("div", {
        className: "list-title"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.title)) : null, /*#__PURE__*/React.createElement("div", {
        className: "list-actions"
      }, this.props.actions != null ? this.props.actions() : null)), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both',
          width: '100%'
        }
      }), this.renderMain());
    }
  }]);

  return DataList;
}(Component);

export default DataList;